import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Y from '../../y18n'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import TopNavigationAppShell from '../../common/top-navigation-app-shell'
import * as accountActions from '../../store/accounts'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  accounts: state.accounts,
  locales: state.locales
})

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(accountActions, dispatch)
})

class SetPasswordPage extends Component {
  state = {
    password: '',
    confirmPassword: '',
    passwordMismatch: false,
    passwordTooShort: false,
    ticketId: '',
    migrationMessage: false
  }

  componentDidMount () {
    var migrationMessage = false
    const urlParams = new URLSearchParams(window.location.search)
    migrationMessage = urlParams.get('auth') !== undefined && urlParams.get('auth') !== null
    const ticketId = this.props.match.params.ticketId
    if (ticketId) {
      this.setState({
        ticketId: ticketId,
        migrationMessage: migrationMessage
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ passwordMismatch: false, passwordTooShort: false })
    if (this.state.password === this.state.confirmPassword) {
      if (this.state.password.length >= 6) {
        this.props.accountActions.setPassword(this.state.ticketId, {password: this.state.password}).then(res => {
          this.props.accountActions.login(this.props.accounts.profile.email, this.state.password).then(res => {
            if (this.state.migrationMessage) {
              this.props.history.push('/profile?auth=true')
            } else if (!this.props.accounts.error) {
              this.props.history.push('/subscriptions')
            }
          })
        })
      } else {
        this.setState({ passwordTooShort: true })
      }
    } else {
      this.setState({
        passwordMismatch: true
      })
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  render () {
    const { classes, locales, accounts } = this.props
    return (
      <TopNavigationAppShell
        content={
          <div className={classes.accountContainer}>
            <Link to={'/'}>
              <img src={locales.logo} alt='logo' className={classes.logo} />
            </Link>
            <Paper elevation={3} square style={{ marginTop: '40px' }}>
              {accounts.loading && <LinearProgress />}
              <div className={classes.content}>
                <div className={classes.textRow}>
                  {this.state.migrationMessage
                    ? <div>
                      <Typography variant='title' className={classes.spacer}>
                        {Y`Welcome the new Hylte SIM website`}
                      </Typography>
                      <Typography variant='body2' className={classes.spacer}>
                        {Y`We are working continuously to improve Hylte SIM. As a part of this we have added new functions which makes it easier to administrate your Hylte SIM cards`}
                      </Typography>
                      <Typography variant='body2' className={classes.spacer}>
                        {Y`Since this is your first visit to this new website, you will need to set a new password for security reasons`}
                      </Typography>
                    </div>
                    : <div>
                      <Typography variant='title'>{Y`Set password`}</Typography>
                      <Typography variant='body2' className={classes.spacer}>
                        {Y`Set a password for your account here`}
                      </Typography>
                    </div>}
                </div>
                <form onSubmit={e => this.handleSubmit(e)}>
                  <TextField
                    className={classes.spacer}
                    label={Y`Password`}
                    id='password'
                    value={this.state.password}
                    onChange={this.handleChange('password')}
                    type='password'
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    helperText={Y`The password must be atleast 6 characters long`}
                    required
                    fullWidth
                  />
                  <TextField
                    style={{ marginTop: '20px' }}
                    label={Y`Confirm password`}
                    id='confirm password'
                    value={this.state.confirmPassword}
                    onChange={this.handleChange('confirmPassword')}
                    type='password'
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: classes.root,
                        input: classes.input
                      }
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: classes.formLabel
                    }}
                    required
                    fullWidth
                  />
                  {this.state.passwordMismatch &&
                    <div className={classes.textRow}>
                      <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                        {Y`Passwords must match`}
                      </Typography>
                    </div>}
                  {this.state.passwordTooShort &&
                    <div className={classes.textRow}>
                      <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                        {Y`The password must be atleast 6 characters long`}
                      </Typography>
                    </div>}
                  {accounts.error &&
                    <div className={classes.textRow}>
                      <Typography variant='body2' className={classes.spacer} style={{ color: 'red' }}>
                        {Y`${accounts.error}`}
                      </Typography>
                    </div>}
                  <div className={classes.buttonRow}>
                    <Button
                      variant='raised'
                      color='primary'
                      style={{ color: '#fff' }}
                      type='submit'
                    >{Y`Save password`}</Button>
                  </div>
                </form>
              </div>
            </Paper>
          </div>
        }
        pageName={'Set password'}
      />
    )
  }
}

SetPasswordPage = connect(mapStateToProps, mapDispatchToProps)(SetPasswordPage)
export default withStyles(Styles)(SetPasswordPage)



// WEBPACK FOOTER //
// ./src/pages/account/set-password.js